/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-border[_ngcontent-%COMP%]{border:0}.mp-0[_ngcontent-%COMP%]{margin:0!important;padding:0!important}.mt-10[_ngcontent-%COMP%]{margin-top:10px!important}.mt-15[_ngcontent-%COMP%]{margin-top:15px!important}.close[_ngcontent-%COMP%]{margin-top:0!important}h2[_ngcontent-%COMP%]{font-weight:500;font-size:1.3rem;margin:2rem 0 0}\n/*# sourceMappingURL=associated-product-assured-exceeded-modal.component.css.map*/"];
export { styles as styles };
